import type { paths as StrapiPaths } from '@core/types/clients/strapi'
import { joinURL } from 'ufo'
import { useStrapiConfig, useOpenapi } from '#imports'

export const useStrapi = () => {
    const { baseUrl } = useStrapiConfig()

    const client = useOpenapi<StrapiPaths>({
        baseUrl: import.meta.server ? '/api' : joinURL(baseUrl, '/api'),
        service: 'strapi',
        enableCookieForwarding: false,
        credentials: 'omit',
    })

    return client
}
